import React, { forwardRef } from 'react';

import Divider from '@material-ui/core/Divider';
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TimelineIcon from '@material-ui/icons/Timeline';

import { ReactComponent as FamilyTreeIcon } from '../images/icons/family-tree.svg'
// import FamilyTreeIcon from '../images/icons/family-tree.svg'


const Parameters = (props, refs) => {
    return (
        <div className="paramBox">
            <div className="paramBoxItem">
                <FamilyTreeIcon className="icon" />
                Here are some parameters
            </div>
            <Divider variant={"fullWidth"} />
            <div className="paramBoxItem">
                <FamilyTreeIcon className="icon" />
                Params
            </div>

            <TreeView
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}
                // defaultEndIcon={<FamilyTreeIcon height={24} width={24} />}
                defaultEndIcon={<FamilyTreeIcon className="icon24 padRight" />}
            >
                <TreeItem nodeId="1" label="Applications">
                    <TreeItem nodeId="2" label="Calendar" />
                    <TreeItem nodeId="3" label="Chrome" />
                    <TreeItem nodeId="4" label="Webstorm" />
                </TreeItem>
                <TreeItem nodeId="5" label="Documents">
                    <TreeItem nodeId="6" label="Material-UI">
                        <TreeItem nodeId="7" label="src">
                            <TreeItem nodeId="8" label="index.js" />
                            <TreeItem nodeId="9" label="tree-view.js" />
                        </TreeItem>
                    </TreeItem>
                </TreeItem>
            </TreeView>
        </div>
    );
};

// Using forwardRef so it can child of Material-UI stuff.
//  See: https://material-ui.com/guides/composition/#caveat-with-refs
export default forwardRef(Parameters);
// export default Parameters;